import 'vant/lib/slider/index.less'

// 依赖
import '../preview-text/style'
